export const fromInvoiceFilterFields = {
  STATUS: 'status',
  MONTH: 'month',
  YEAR: 'year',
  PRESENTER: 'legalEntityId',
};
